import { Moon, Sun } from "lucide-react";
import { useTheme } from "./theme-provider";

export function ThemeToggle({
  className = "",
}: {
  className?: string;
}): React.JSX.Element {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  const Icon = isDark ? Sun : Moon;
  return (
    <button
      onClick={toggleTheme}
      title={isDark ? "Switch to light theme" : "Switch to dark theme"}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      className={`inline-flex items-center gap-2 rounded-lg border border-fc-border bg-fc-surface px-3 py-2 text-[12px] font-semibold text-fc-text-secondary hover:text-fc-text hover:border-fc-border-light transition-all ${className}`}
    >
      <Icon className="w-4 h-4" />
      {isDark ? "Light" : "Dark"}
    </button>
  );
}
